import React from "react";
import styles from "./styles.module.css";
import RightArrow from "../../images/RightArrow";

const CTAButton = ({ className = "", titleClass, subtitleClass, iconClass, arrowClass}) => {
    function handleCTA() {

        const url = 'https://www.amazon.com/dp/B0C4XTH7RH'
        window.open(url, '_blank')
    }

    const isMobile = window.innerWidth <= 1140 

    return (
        <button className={`${styles.cta_button} ${className}`} onClick={handleCTA}>
            <div>
                <img src={require('./amazon_ic.png')} className={!iconClass ? styles.shopee : iconClass} />
                <div style={{gap: 0}}>
                    <span className={titleClass} style={{color: '#fff', marginLeft: -20}}>
                        Buy now on Amazon
                    </span>
                    {/* <span className={subtitleClass} style={{color: "#FFBAA1", fontSize: isMobile ? "12px" : "18px", fontWeight: 400, marginTop: isMobile ? "0px" : "12px"}}>Free Shipping on Shopee</span> */}
                </div>
                <img src={require('./arrow.png')} className={!arrowClass ? styles.arrow : arrowClass} />
            </div>
        </button>
    )
}

export default CTAButton